import { createContext, useContext } from "react";

const TeamChipPersistenceContext = createContext(null);

/**
 * When editing team (project) chips, provides `projectId` and save/delete callbacks so
 * variable flows can call project-variable APIs instead of workflow APIs.
 */
export const TeamChipPersistenceProvider = ({ value, children }) => (
  <TeamChipPersistenceContext.Provider value={value}>{children}</TeamChipPersistenceContext.Provider>
);

export const useTeamChipPersistence = () => useContext(TeamChipPersistenceContext);
